export default () => ({
  type: "FAVORITE/CANCEL"
});
